import React from 'react';
import { connect } from 'react-redux';
// Sidebar imports
import Background from './background';
import { setActiveSidebarItem } from '../../../actions/sideBarActions';
// Game(kit) imports
import gameKit from '../../../../GameKit';
import LibraryManager from '../../../../Game/Base/Library/LibraryManager';
// Shared/Default imports
import { SideBarItems } from '../../../shared';
import CircleIconButton from '../../Default/CircleIconButton';

import settings from '../../../../settings';

class BackgroundEditor extends React.Component {
    setActiveItem = item => {
        const { dispatch } = this.props;
        dispatch(setActiveSidebarItem(item));
    };

    handleSelectColor = () => {
        const { sideBar } = this.props;

        if (sideBar.activeItem === SideBarItems.BACKGROUND_COLOR) {
            gameKit.levelEditor.tileEditor.startDrawMode();
            return;
        }
        this.setActiveItem(SideBarItems.BACKGROUND_COLOR);
    };

    handleSelectDraw = () => {
        const { sideBar } = this.props;

        if (sideBar.activeItem === SideBarItems.BACKGROUND_DRAW) {
            return;
        }
        gameKit.levelEditor.tileEditor.startDrawMode();
    };

    handleSelectErase = () => {
        const { sideBar } = this.props;

        if (sideBar.activeItem === SideBarItems.BACKGROUND_ERASE) {
            this.setActiveItem(SideBarItems.BACKGROUND_DRAW);
            return;
        }
        gameKit.levelEditor.tileEditor.startEraseMode();
    };

    render() {
        const { sideBar, closeSideBar, levelEditor } = this.props;

        let activeBlockUrl;

        if (levelEditor.backgroundEditorTileId) {
            activeBlockUrl = LibraryManager.textures.get(levelEditor.backgroundEditorTileId).get().baseTexture.imageUrl;
        }

        let page = null;
        if (sideBar.activeItem === SideBarItems.BACKGROUND_COLOR) {
            page = (
                <Background
                    closeSideBar={closeSideBar}
                    activeItem={sideBar.activeItem}
                    handleSelectColor={this.handleSelectColor}
                    handleSelectDraw={this.handleSelectDraw}
                    handleSelectErase={this.handleSelectErase}
                    activeBlockUrl={activeBlockUrl}
                />
            );
        }

        return (
            <>
                <div className="side-bar-items">
                    <div className="side-bar-item">
                        <CircleIconButton
                            active={sideBar.activeItem === SideBarItems.BACKGROUND_COLOR}
                            onClick={this.handleSelectColor}
                            src={`${settings.assetsPath}img/icons/color_buckit.png`}
                            iconStyle={{ width: '2.5rem', height: '2.5rem', margin: '0.5rem' }}
                        />
                    </div>
                    <div className="side-bar-item">
                        <CircleIconButton
                            active={sideBar.activeItem === SideBarItems.BACKGROUND_DRAW}
                            onClick={this.handleSelectDraw}
                            src={`${settings.assetsPath}img/icons/kwast.png`}
                            backgroundSrc={activeBlockUrl}
                            iconStyle={{ width: '2.5rem', height: '2.5rem', margin: '0.5rem' }}
                        />
                    </div>
                    <div className="side-bar-item">
                        <CircleIconButton
                            active={sideBar.activeItem === SideBarItems.BACKGROUND_ERASE}
                            onClick={this.handleSelectErase}
                            src={`${settings.assetsPath}img/icons/eraser.png`}
                            iconStyle={{ width: '2.5rem', height: '2.5rem', margin: '0.5rem' }}
                        />
                    </div>
                </div>
                <div
                    className={`side-bar-page${
                        sideBar.activeItem !== SideBarItems.NONE &&
                        sideBar.activeItem !== SideBarItems.ACTIVE &&
                        sideBar.activeItem !== SideBarItems.BACKGROUND_DRAW &&
                        sideBar.activeItem !== SideBarItems.BACKGROUND_ERASE
                            ? ' side-bar-page-active'
                            : ''
                    }`}
                >
                    <div className="side-bar-content">{page}</div>
                </div>
            </>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    sideBar: state.sideBar,
    levelEditor: state.levelEditor
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BackgroundEditor);
